import { createFileRoute, redirect } from '@tanstack/react-router';

import { ensureDeveloperEnabled } from '@/features/developers/guard.js';

/**
 * Legacy `/developers` list URL — the section lives at `/developer` (singular, workspace-scoped).
 */
export const Route = createFileRoute('/developers/')({
  beforeLoad: async () => {
    await ensureDeveloperEnabled();
    throw redirect({ to: '/developer', replace: true });
  },
});
